export default __webpack_public_path__ + "static/media/404-error-page-not-found-miss-paper-with-white-vector-20577349.adc282a5.jpg";